module.exports = {
	"ha": "viha",
	"id": 9,
	"report": {
		"ha": "Island Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 700,
			"height": 380,
			"marginLeft": 100,
			"marginRight": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 9</span>                 <span style=\"display: table-cell;\">Active and Inactive DTP Participants in Island Health, 2022 Q1–2023 Q4 <sup style=\"font-size: 10px;\">15</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2022",
					"2022",
					"2022",
					"2022",
					"2023",
					"2023",
					"2023",
					"2023"
				],
				"tickPositions": [
					0,
					4
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": "10",
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# Participants",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "Active",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					1005,
					1015,
					1023,
					1035,
					1035,
					1034,
					1037,
					{
						"y": 1043,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Active</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Inactive",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					62,
					60,
					62,
					64,
					59,
					58,
					57,
					{
						"y": 69,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Inactive</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"dataTable": {
			"< 30": 31,
			"30–39": 112,
			"40–49": 182,
			"≥ 50": 718,
			"Male": 875,
			"Female": 168,
			"MSM": 429,
			"PWID": 224,
			"Total": 1043
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_viha_9.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_viha_9.json
// module id = 42
// module chunks = 0